// AstroVoyance data-testids
export const NAV = {
  logo: "nav-logo",
  linkOracles: "nav-link-oracles",
  linkBarde: "nav-link-barde",
  linkAstro: "nav-link-astro",
  linkDruide: "nav-link-druide",
  linkPricing: "nav-link-pricing",
  linkTaverne: "nav-link-taverne",
  linkVate: "nav-link-vate",
  linkFarfadet: "nav-link-farfadet",
  linkGrammarien: "nav-link-grammarien",
  linkKorrigan: "nav-link-korrigan",
  linkTraditions: "nav-link-traditions",
  ctaPricing: "nav-cta-pricing",
  mobileToggle: "nav-mobile-toggle",
  emailBadge: "nav-email-badge",
};

export const HERO = {
  section: "hero-section",
  title: "hero-title",
  ctaOracles: "hero-cta-oracles",
  ctaBarde: "hero-cta-barde",
  emailInput: "hero-email-input",
  emailSubmit: "hero-email-submit",
};

export const ORACLES = {
  section: "oracles-section",
  card: (id) => `oracle-card-${id}`,
  input: (id) => `oracle-input-${id}`,
  ask: (id) => `oracle-ask-${id}`,
  answer: (id) => `oracle-answer-${id}`,
  counter: "oracle-counter",
};

export const BARDE = {
  section: "barde-section",
  input: "barde-input",
  send: "barde-send",
  message: (i) => `barde-msg-${i}`,
  emailInput: "barde-email",
};

export const DRUIDE = {
  section: "druide-section",
  input: "druide-input",
  send: "druide-send",
  message: (i) => `druide-msg-${i}`,
  upgrade: "druide-upgrade",
};

export const ASTRO = {
  section: "astro-section",
  emailInput: "astro-email",
  birthDate: "astro-birth-date",
  birthTime: "astro-birth-time",
  birthPlace: "astro-birth-place",
  focus: (v) => `astro-focus-${v}`,
  submit: "astro-submit",
  result: "astro-result",
};

export const DESTINATION = {
  section: "destination-section",
  intent: (v) => `destination-intent-${v}`,
  submit: "destination-submit",
  buyAddon: "destination-buy-addon",
  result: "destination-result",
};

export const PRICING = {
  section: "pricing-section",
  emailInput: "pricing-email-input",
  buyPremium: "pricing-buy-premium",
  buyDestination: "pricing-buy-destination",
};

export const NEWSLETTER = {
  section: "newsletter-section",
  nameInput: "newsletter-name",
  emailInput: "newsletter-email",
  submit: "newsletter-submit",
  success: "newsletter-success",
};

export const FOOTER = { root: "footer-root" };

export const TAVERNE = {
  section: "taverne-section",
  page: "taverne-page",
  filterAll: "taverne-filter-all",
  filterReflexif: "taverne-filter-reflexif",
  filterSlam: "taverne-filter-slam",
  filterSatirique: "taverne-filter-satirique",
  card: (id) => `taverne-card-${id}`,
  play: (id) => `taverne-play-${id}`,
  stop: (id) => `taverne-stop-${id}`,
  usage: "taverne-usage",
  musicToggle: "taverne-music-toggle",
  upgrade: "taverne-upgrade",
};

export const VATE = {
  page: "vate-page",
  ageGate: "vate-age-gate",
  ageAdultBtn: "vate-age-adult",
  ageMinorBtn: "vate-age-minor",
  chatBox: "vate-chat-box",
  input: "vate-input",
  send: "vate-send",
  clear: "vate-clear",
  suggestion: (idx) => `vate-suggestion-${idx}`,
  crisisBanner: "vate-crisis-banner",
  modeBadge: "vate-mode-badge",
};

export const FARFADET_PAGE = {
  page: "farfadet-page",
  chatBox: "farfadet-chat-box",
  input: "farfadet-input",
  send: "farfadet-send",
  clear: "farfadet-clear",
  suggestion: (idx) => `farfadet-suggestion-${idx}`,
  daily: "farfadet-daily-joke",
  rateUp: (idx) => `farfadet-rate-up-${idx}`,
  rateDown: (idx) => `farfadet-rate-down-${idx}`,
  share: (idx) => `farfadet-share-${idx}`,
  subscribeForm: "farfadet-subscribe-form",
  subscribeEmail: "farfadet-subscribe-email",
  subscribeSubmit: "farfadet-subscribe-submit",
};

export const GRAMMARIEN = {
  page: "grammarien-page",
  chatBox: "grammarien-chat-box",
  input: "grammarien-input",
  send: "grammarien-send",
  clear: "grammarien-clear",
  usage: "grammarien-usage",
  suggestion: (idx) => `grammarien-suggestion-${idx}`,
  langChip: (id) => `grammarien-lang-${id}`,
};

export const TRADITIONS = {
  page: "traditions-page",
  card: (id) => `traditions-card-${id}`,
};

export const KORRIGAN = {
  page: "korrigan-page",
  chatBox: "korrigan-chat-box",
  input: "korrigan-input",
  send: "korrigan-send",
  clear: "korrigan-clear",
  suggestion: (idx) => `korrigan-suggestion-${idx}`,
};
